/*
  Das Zeitfenster, das der Schichtplan gerade zeigt.

  Warum als Modul und nicht als Parameter: Der Server beantwortet ein Dutzend
  Aufrufe mit dem vollständigen Plan — auch solche aus tief liegenden
  Bedienfeldern (Absenztypen anlegen, Abteilungsfarbe ändern). Ohne diese
  Stelle müsste das Fenster als Eigenschaft durch den halben Komponentenbaum
  gereicht werden, obwohl es keine dieser Komponenten inhaltlich betrifft.

  Es gehört zur Anfrage, nicht zum Aufrufer — wie der Standort-Kopf, den
  httpClient.js setzt.
*/

let activePeriod = { startDate: "", endDate: "" };

export function setActivePeriod({ startDate, endDate } = {}) {
  activePeriod = {
    startDate: String(startDate || ""),
    endDate: String(endDate || ""),
  };
  return activePeriod;
}

export function getActivePeriod() {
  return activePeriod;
}

/*
  Die Abfrageparameter für einen Aufruf, der den Plan zurückgibt.

  Ist noch kein Fenster gesetzt (der erste Aufruf vor dem ersten Rendern),
  bleiben die Parameter weg. Das Backend antwortet dann mit dem laufenden
  Monat — für den Schichtplan die richtige Vermutung, und in keinem Fall das
  ganze Archiv.
*/
export function activePeriodParams() {
  const { startDate, endDate } = activePeriod;
  if (!startDate || !endDate) return {};
  return { start_date: startDate, end_date: endDate };
}

export function resetActivePeriod() {
  return setActivePeriod({});
}
